module.exports = __webpack_public_path__ + "static/media/ic-copy-tna.27f6d7b3.svg";